/** iconfont script url */
export const ICONFONT_SCRIPT_URL = '//at.alicdn.com/t/c/font_4767907_urf39h65i4e.js'
